import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { CounterInputV2 } from "../../../../FormControlsV2";
import { MessageBalloon } from "../../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../../assets/svg/icons/point.svg";
import { ReactComponent as GrassIcon } from "../../../../../assets/svg/icons/grass.svg";

interface InfoCollectRateProps {
  task: ITaskCollect | undefined;
}

const ratingDescriptions = [
  "bare",
  "exitPoint",
  "grazingPoint",
  "entryPoint",
  "overgrown",
] as const;

function resolveMaxRate(maxRate: number | undefined) {
  const parsedMaxRate = Number(maxRate);
  return parsedMaxRate === 5 || parsedMaxRate === 10 ? parsedMaxRate : 10;
}

function getRatingDescription(rating: number, maxRate: number) {
  const normalizedRating = Math.min(Math.max(Math.floor(Number(rating) || 1), 1), maxRate);
  const descriptionIndex = maxRate === 5
    ? normalizedRating - 1
    : Math.floor((normalizedRating - 1) / 2);

  return ratingDescriptions[descriptionIndex];
}

export default function InfoCollectRate({ task }: InfoCollectRateProps) {
  const { t } = useTranslation();
  const [taskCollect, setTaskCollect] = useState<ITaskCollect>();

  useEffect(() => {
    setTaskCollect(task);
  }, [task]);

  if (!taskCollect) return null;

  const maxRate = resolveMaxRate(taskCollect.max_rate);
  const ratingDescription = t(`ratingScale.${getRatingDescription(taskCollect.monitor_value, maxRate)}`);

  function updateRating(monitorValue: number) {
    setTaskCollect((currentTask) => currentTask
      ? {
          ...currentTask,
          monitor_value: monitorValue,
          max_rate: maxRate,
        }
      : currentTask
    );
  }

  return (
    <>
      <div>
        <span><Trans i18nKey="taskDetails.onPaddock" /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <GrassIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskCollect.initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={`Informar a nota do pasto`} pointed />
      </div>

      <div className="containerQuestion">
        <h5><Trans i18nKey="taskDetails.rating" /></h5>
        <CounterInputV2
          name="info-collect-rate"
          value={taskCollect.monitor_value}
          min={1}
          max={maxRate}
          description={ratingDescription}
          onChange={updateRating}
          disabled
        />
      </div>
    </>
  )
}
